import { render } from "./RiNotice.vue?vue&type=template&id=5b571ce5"
import script from "./RiNotice.vue?vue&type=script&lang=js"
export * from "./RiNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiNotice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b571ce5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b571ce5', __exports__)) {
    api.reload('5b571ce5', __exports__)
  }
  
  module.hot.accept("./RiNotice.vue?vue&type=template&id=5b571ce5", () => {
    api.rerender('5b571ce5', render)
  })

}


export default __exports__